/** @format */

import React, { useContext, useState, useEffect } from "react";
import { DataContext } from "../context/DataContext";
import Footer from "../components/Footer";

/* Begin By Javi */
import Header from "./Header";
import { Loader } from "../util/loader";
import utils from "./../util";
import { apiEstudiante } from "../api";
/* End By Javi */

const { isMobile } = utils;
export const Estudiante = () => {
  /* Begin By Javi */
  const [Loading, setloading] = useState(true);
  const [alertMessage, setMessage] = useState("Estudiantes UPN");
  /* End By Javi */
  const { data, setData } = useContext(DataContext);
  const [_isMobile] = useState(isMobile());
  const [listStudents, setListStudents] = useState([]);

  function capitalizarPrimeraLetra(str) {
    let result = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    return result;
  }

  useEffect(() => {
    const fetchEstudiantes = async () => {
      try {
        const dataUser = JSON.parse(localStorage.getItem("userLogin"));

        const res = await apiEstudiante.listar(
          dataUser.detail.apoderado_id,
          alertMessage
        );
  
        if (Array.isArray(res) && res.length > 0) {
          const arrayStudent = res.map((student) => ({
            Codigo: student.codigo,
            Nombres: capitalizarPrimeraLetra(student.nombres),
            Carrera: student.carrera,
            Programa: "",
            Foto: student.Foto,
            Ciclo: student.Ciclo,
          }));
  
          setListStudents(arrayStudent);
          setData((prev) => ({ ...prev, students: arrayStudent }));
          setloading(false);          
  
          if (arrayStudent.length === 1) {

            console.log(JSON.stringify(arrayStudent[0]));

            localStorage.setItem("studientActive", JSON.stringify(arrayStudent[0]));
            ChangeStudentHandler(
              arrayStudent[0].Codigo,
              arrayStudent[0].Nombres,
              arrayStudent[0].Carrera,
              arrayStudent[0].Ciclo,
              arrayStudent[0].Foto
            );
            window.location.href = "./curso";
          } else {
            localStorage.setItem("studientList", JSON.stringify(arrayStudent));
          }
        } else {
          setloading(false);
          console.warn("No se encontraron estudiantes.");
        }
      } catch (error) {
        setloading(false);
        console.error("Error al listar estudiantes:", error);
      }
    };
  
    fetchEstudiantes();
  }, [setListStudents]);
  

  const ChangeStudentHandler = (Codigo, Nombres, Carrera, Ciclo, Foto) => {
    const objStudent = {
      Codigo: Codigo,
      Nombres: Nombres,
      Carrera: Carrera,
      Ciclo: Ciclo,
      courseSection: 123,
      Foto: Foto,
    };
    setData({ ...data, student: objStudent });    
    localStorage.setItem("studientActive", JSON.stringify(objStudent));
  };
  return (
    <div>
      {Loader(Loading)}
      {_isMobile ? (
        <>
          <div className="contend">
            <div className="text col-12">
              <Header
                objData={data}
                page={"E"}
                objlistStudents={listStudents}
                ChangeStudentHandler={ChangeStudentHandler}
                isMobile={_isMobile}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="contend">
            <div className="text col-12">
              <Header
                objData={data}
                page={"E"}
                objlistStudents={listStudents}
                ChangeStudentHandler={ChangeStudentHandler}
                isMobile={_isMobile}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
